import React, { useMemo } from 'react';

const Stars = ({ count = 40 }) => {
  const stars = useMemo(() => {
    return [...Array(count)].map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: Math.random() > 0.85 ? 2 : 1,
      opacity: Math.random() * 0.2 + 0.1,
      delay: Math.random() * 4,
      duration: 4 + Math.random() * 3
    }));
  }, [count]);

  return (
    <div className="stars-container">
      {stars.map(star => (
        <div
          key={star.id}
          className="star"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            width: star.size,
            height: star.size,
            opacity: star.opacity,
            animationDelay: `${star.delay}s`,
            animationDuration: `${star.duration}s`
          }}
        />
      ))}
    </div>
  );
};

export default Stars;
